import { create } from 'zustand';
import IAppStore from "../interfaces/IAppStore";

const useAppStore = create<IAppStore>((set) => ({
    initialLoading: true,
    isTest: false,
    allowAnalytics: false,

    pageLoad: 0,
    setPageLoad: (performance) => set(() => ({pageLoad: performance})),

    pricingRefs: [],
    setPricingRefs: (ref) => set((state) => ({pricingRefs: [...state.pricingRefs, ref]})),

    hideFloaterRefs: [],
    setHideFloaterRefs: (ref) => set((state) => ({hideFloaterRefs: [...state.hideFloaterRefs, ref]})),

    paymentLoading: false,
    setPaymentLoading: (status) => set(() => ({paymentLoading: status})),

    appliedDiscount: false,
    applyDiscount: () => set(() => ({appliedDiscount: true})),

    currency: 'usd',
    setCurrency: (currency) => ({currency}),

    activeTier: null,
    setActiveTier: (tier) => set(() => ({activeTier: tier})),

    allowScroll: true,
    setAllowScroll: (status) => set(() => ({allowScroll: status})),

    showCookies: false,
    setShowCookies: (status) => set(() => ({showCookies: status})),

    userCookies: {},
    setUserCookies: (cookies) => set(() => ({userCookies: cookies})),

    system: {
        find: false,
        expire: null
    },
    setSystem: (find, expire) => set(() => ({system: {find, expire}})),

    userPayload: {},
    setUserPayload: (key, data) => set((state) => ({userPayload: {...state.userPayload, [key]: data}})),

    alert: {
        isOpen: false,
        title: null,
        description: [],
        button: null
    },
    openAlert: (title, description, button) => set(() => ({allowScroll: false, alert: {isOpen: true, title, description, button}})),
    closeAlert: () => set((state) => ({allowScroll: true, alert: {...state.alert, isOpen: false}})),

    processedScreenIndex: null,
    setProcessedScreenIndex: (index) => set(() => ({processedScreenIndex: index})),

    currentScreenIndex: 0,
    prevScreenIndex: 0,
    goToStepByIndex: (prev, next) => set(() => {
        return {prevScreenIndex: prev, currentScreenIndex: next}
    }),

    finish: { funnel: false, paywall: false },
    setFinish: (key, value) => set((state) => ({finish: {...state.finish, [key]: value}})),

    project: { logo: null, logo_inverted: null, name: null, appstore: null, deeplink: null },
    setProject: (logo) => set((state) => {
        setTimeout(() => {
            set({initialLoading: false})
        }, 200);

        return {project: {...state.project, logo}}
    }),

    email: '',
    setEmail: (email) => set(() => ({email: email})),

    token: null,
    setToken: (token) => set(() => ({token})),

    fbc: null,
    setFbc: (fbc) => set(() => ({fbc})),

    code: null,
    setCode: (code) => set(() => ({code: code})),

    user_id: null,
    hash_id: null,
    service: null,
    variant: null,

    funnel: null,
    screens: [],

    paywall: null,
    blocks: [],

    offer: null,
    offerPayload: {
        type: 'single',
        price: null,
        oldPrice: null,
        percent: null,
    },
    offerBlocks: [],

    common: {steps: true, theme: "light", title: "2xl", arrow: false, cookie: true},

    payload: {
        emotion: null
    },
    setPayload: (key, value) => set((state) => {
        return {
            payload: {
                ...state.payload,
                [key]: value
            }
        }
    }),

    upsell: null,
    setUpsell: (upsell) => set(() => ({upsell})),

    setSettings: (variant, funnel, paywall, offer, common, finish, project, email, code, user_id, hash_id, service, isTest, allowAnalytics) => set(() => {
        setTimeout(() => {
            set({initialLoading: false})
        }, 200);

        return {
            variant: variant,
            funnel: funnel?.id,
            screens: funnel?.items,
            paywall: paywall?.id,
            blocks: paywall?.items,
            offer: offer?.id,
            offerPayload: {
                type: offer?.type ?? 'single',
                price: offer?.price,
                oldPrice: offer?.oldPrice,
                percent: offer?.percent
            },
            offerBlocks: offer?.items,
            common: common,
            finish,
            project,
            user_id,
            hash_id,
            service,
            email,
            code,
            isTest,
            allowAnalytics
        }
    }),
    setScreenValue: (value) => set((state) => {
        if(!value) return {screens: state.screens};
        return {screens: state.screens.map((screen, index) => {
            if(index === state.currentScreenIndex) {
                const newScreen = {...screen};
                newScreen.value = value;
                return newScreen;
            }

            return screen;
        })}
    })
}));

export default useAppStore